import {
  DUTCH_API_CALL_WIZARD_API_SUCCESS,
  DUTCH_API_CALL_WIZARD_API_ERROR,
} from '../../../constants/wizardActionNames';
import {
  filterConditions,
  makeRequestBody,
} from '../../../componentsV2/wizards/functions';

import { processFileUploadParams } from '../../../componentsV2/wizards/components/ggilComponents/helpers';
import { getMotorPremiumWizardApi } from '../../../apis/wizards';
import { maybeUpdateSumInsured } from '../apiCallWizard';

function dutchApiCallWizardError(err, savedKey) {
  return {
    type: DUTCH_API_CALL_WIZARD_API_ERROR,
    payload: err,
    savedKey,
  };
}
function dutchApiCallWizardSuccess(prod, savedKey) {
  return {
    type: DUTCH_API_CALL_WIZARD_API_SUCCESS,
    payload: prod,
    savedKey,
  };
}

export function getPremiumAction(requestParams, savedKey, currResponse, requestUrl) {
  return async (dispatch, getState) => {
    const state = getState();
    try {
      const filteredParams = requestParams.filter(param => filterConditions(param, state));
      const data = await getMotorPremiumWizardApi.getPremuim(
        state,
        {
          ...makeRequestBody(
            state,
            filteredParams,
            currResponse,
          ),
          ...processFileUploadParams(state, filteredParams),
        },
        requestUrl,
      );
      dispatch(dutchApiCallWizardSuccess(data, savedKey));
      return data;
    } catch (error) {
      dispatch(dutchApiCallWizardError(error, savedKey));
      // Only the 422 rejection carries an increased Sum Insured to prepopulate.
      maybeUpdateSumInsured(dispatch, error);
      throw error;
    }
  };
}

export default {
  getPremiumAction,
};
